import * as React from 'react';

import { PrimitiveTabs } from 'components';
import { useBrandAction, useBrandValue } from 'context';

import { BrandBaseInfo } from './base-info';
import { BrandFilesInfo } from './files-info';
import { BrandSeoInfo } from './seo-info';

const BrandFormTabs = () => {
  const { step = 1 } = useBrandValue();
  const action = useBrandAction();

  return (
    <PrimitiveTabs
      items={[
        {
          key: '1',
          label: 'اطلاعات اولیه',
          children: <BrandBaseInfo />,
        },
        {
          key: '2',
          label: 'مدیریت مستندات',
          children: <BrandFilesInfo />,
          disabled: step < 2,
        },
        {
          key: '3',
          label: 'تنظیمات سئو',
          children: <BrandSeoInfo />,
          disabled: step < 3,
        },
      ]}
      activeKey={step.toString()}
      onChange={activeKey => {
        action({
          type: 'UPDATE_BRAND_STEP',
          payload: {
            step: +activeKey as typeof step,
          },
        });
      }}
    />
  );
};

export { BrandFormTabs };
